import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState
} from 'react'
import PropTypes from 'prop-types'

const NOOP_MODAL = {
  feature: null,
  isOpen: false,
  open: () => {},
  close: () => {}
}

const CsvExportLimitModalContext = createContext(null)

export const CsvExportLimitModalProvider = ({ children }) => {
  const [feature, setFeature] = useState(null)

  const open = useCallback(featureLimitKey => setFeature(featureLimitKey), [])
  const close = useCallback(() => setFeature(null), [])

  const value = useMemo(
    () => ({ feature, isOpen: feature !== null, open, close }),
    [feature, open, close]
  )

  return (
    <CsvExportLimitModalContext.Provider value={value}>
      {children}
    </CsvExportLimitModalContext.Provider>
  )
}

CsvExportLimitModalProvider.propTypes = {
  children: PropTypes.node
}

export const useCsvExportLimitModal = () => {
  return useContext(CsvExportLimitModalContext) || NOOP_MODAL
}
